import styled from "styled-components";
import { Box, type TypeBoxProps } from "@sproutsocial/seeds-react-box";

export interface TypeDefaultMenuEmptyStateProps extends TypeBoxProps {
  children?: React.ReactNode;
}

const StyledEmptyState = styled(Box)`
  padding: ${({ theme }) => theme.space[350]};
  text-align: center;
  font-size: ${({ theme }) => theme.typography[200].fontSize};
`;

const DefaultMenuEmptyState = ({
  children = "No items found",
  ...props
}: TypeDefaultMenuEmptyStateProps) => {
  return <StyledEmptyState {...props}>{children}</StyledEmptyState>;
};

export { DefaultMenuEmptyState };
